import { useState, useEffect } from "react";
import { Minus, Plus, Type } from "lucide-react";

const MIN_SIZE = 14;
const MAX_SIZE = 24;
const STEP = 2;

export default function FontScaler() {
  const [size, setSize] = useState<number>(() => {
    const stored = Number(localStorage.getItem("fontSize")) || 16;
    return Math.min(MAX_SIZE, Math.max(MIN_SIZE, stored));
  });

  useEffect(() => {
    document.documentElement.style.fontSize = `${size}px`;
    localStorage.setItem("fontSize", String(size));
  }, [size]);

  const decrease = () => setSize((prev) => Math.max(MIN_SIZE, prev - STEP));
  const increase = () => setSize((prev) => Math.min(MAX_SIZE, prev + STEP));

  return (
    <div className="flex items-center rounded-lg bg-ink/5">
      <button
        onClick={decrease}
        disabled={size <= MIN_SIZE}
        className={`p-1 transition-colors ${size <= MIN_SIZE ? "text-gray-600" : "text-ink/50 hover:text-ink"}`}
        title="Decrease font size"
      >
        <Minus size={14} />
      </button>
      <Type size={16} className="text-ink/50" />
      <button
        onClick={increase}
        disabled={size >= MAX_SIZE}
        className={`p-1 transition-colors ${size >= MAX_SIZE ? "text-gray-600" : "text-ink/50 hover:text-ink"}`}
        title="Increase font size"
      >
        <Plus size={14} />
      </button>
    </div>
  );
}
